import { Middleware } from "@reduxjs/toolkit";
import { endLoading, resetLoading, startLoading, } from "../slices/loadingSlice";
import { LOADING_MIDDLEWARE_TIMEOUT } from "../../env";
let timer: any = null;

export const loadingMiddleware: Middleware = store => next => action => {
    const result = next(action);
    if (result.type === startLoading.type || result.type === endLoading.type) {
        const count = store.getState().loading.count;
        // Hủy timer cũ
        if (timer) clearTimeout(timer);

        // Nếu count >= 1 trong quá lâu -> reset
        if (count >= 1) {
            timer = setTimeout(() => {
                const current = store.getState().loading.count;
                // kiểm tra lại để chắc chắn vẫn >=1
                if (current >= 1) {
                    store.dispatch(resetLoading());
                }
            }, LOADING_MIDDLEWARE_TIMEOUT);
        }
    }

    return result;
};
